/**
* tab content JS
* -----------------------------------------------------------------------------
*
* All the JS for the tab content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'tab-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      $( '.tab_content .sub-column' ).css( 'min-height', $( '.tab_content .sub-column-content:first-child' ).outerHeight() );
      $( '.tab_content .category button' ).on( 'toggleAfter', ( event ) => {
        // $( $( event.target ) ).fadeToggle();
        $( '.service-menus .sub-column' ).css( 'min-height', $( $( event.target ) ).outerHeight() );
      } );

      $( '.tab-content__button' ).on( 'toggleAfter', ( event ) => {
        if ( window.easyToggleState.isActive( event.target ) ) {
          $( event.target ).attr( 'tabindex', 0 );
        } else {
          $( event.target ).attr( 'tabindex', -1 );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'tab-content', COMPONENT );
} )( app );
